import RequesterTBPage from "@/pages/toolbox/RequesterTBPage.vue";
import RequesterTBDetails from "@/pages/toolbox/RequesterTBDetails.vue";

export default [
  {
    path: '/requestTB/',
    component: RequesterTBPage
  },
  {
    path: '/requestTBDetails/:id',
    component: RequesterTBDetails
  }
]
